module.exports = __webpack_public_path__ + "img/yjs.4b55ef01.png";